import { UzCombobox } from '@utazzo/ui';

import { usePickerOptions } from './usePickerOptions';

import * as vehicleTypesApi from '@/features/vehicle-types/vehicle-types.api';

interface VehicleTypePickerProps {
  label?: string;
  value: string | null;
  onValueChange: (value: string | null) => void;
  required?: boolean;
  disabled?: boolean;
  error?: string;
  hint?: string;
}

export const VehicleTypePicker = ({
  label = 'Vehicle type',
  value,
  onValueChange,
  required,
  disabled,
  error,
  hint,
}: VehicleTypePickerProps): React.JSX.Element => {
  const { options, loading, setSearch } = usePickerOptions(
    {
      cacheKey: 'picker.vehicleTypes',
      fetch: async (search) => {
        const res = await vehicleTypesApi.listVehicleTypes({
          page: 1,
          pageSize: 30,
          sortDir: 'asc',
          ...(search ? { search } : {}),
        });
        return res.data;
      },
      fetchOne: async (id) => {
        try {
          return await vehicleTypesApi.getVehicleType(id);
        } catch {
          return null;
        }
      },
      toOption: (v) => ({
        value: v.id,
        label: v.name,
        description: v.code ?? undefined,
      }),
    },
    value,
  );

  return (
    <UzCombobox
      label={label}
      placeholder="Select a vehicle type"
      searchPlaceholder="Search vehicle types..."
      value={value ?? ''}
      onValueChange={(v) => onValueChange(v || null)}
      onSearchChange={setSearch}
      options={options}
      loading={loading}
      required={required}
      disabled={disabled}
      error={error}
      hint={hint}
    />
  );
};
